import { render, staticRenderFns } from "./DynamicFile.vue?vue&type=template&id=9e75e8b0&scoped=true&"
import script from "./DynamicFile.vue?vue&type=script&lang=js&"
export * from "./DynamicFile.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFile.vue?vue&type=style&index=0&id=9e75e8b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e75e8b0",
  null
  
)

export default component.exports